/*
 * @Author: leventlei
 * @Date: 2024-04-13 11:45:10
 * @LastEditTime: 2024-09-23 17:40:12
 * @LastEditors: leventlei
 * @Description:带新增Icon的按钮
 * @FilePath: /IOT4CMS/src/components/ButtonForCreate/index.tsx
 */
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'
import { Button } from 'antd'
import React, { FC } from 'react'

interface ButtonForCreateProps {
	text: string
	onClick: () => void
	loading?: boolean
	width?: number | string
	height?: number | string
	type?: any
}

const ButtonForCreate: FC<ButtonForCreateProps> = ({
	text,
	onClick,
	loading,
	width,
	height,
	type,
}) => {
	return (
		<Button
			type={type ?? 'primary'}
			onClick={onClick}
			icon={<PlusOutlined />}
			loading={loading ?? false}
			style={{ width: width ?? 'auto', height: height ?? 'auto' }}
		>
			{text}
		</Button>
	)
}

export default ButtonForCreate
